import { Box, Button, CircularProgress, Divider, Stack, Typography } from '@mui/material'
import React from 'react'
import { TtrainingKeyParameter } from '../../shared/types/trainingKeyParameter.type'
import { TgroupKeyParam } from '../../shared/utils/comparaison'
import ComparaisonCard from './ComparaisonCard'
import { t } from 'i18next'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { Ttraining } from '../../shared/types/training.type'

type ComparaisonSectionProps = {
    loading: boolean,
    categories: TgroupKeyParam[],
    data?: TtrainingKeyParameter
    compare: () => void,
    onSelectExam?: (exam: string, checked: boolean) => void,
    selectedExams?: string[],
    canChangeParam?: boolean,
    showExplenation?: boolean,
    printable?: boolean,
}

function ComparaisonSection({ loading, categories, data, compare, onSelectExam, selectedExams, canChangeParam = true, showExplenation = true, printable }: ComparaisonSectionProps) {

    const checkedExams = useSelector<RootState>(state => state.comparaison.checkedExams) as Ttraining[]

    return (
        <>
            {loading ? <Box display={'flex'} justifyContent={'center'} mt={3} alignItems={'center'} >
                <CircularProgress></CircularProgress>
            </Box>
                : (!data || data?.items?.length === 0) ?
                    <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                        {
                            checkedExams.length > 0 ?
                                <Button onClick={compare}>{t('compareHorseSelection:send')}</Button>
                                : <Typography variant='subtitle2'>{t('no_training')}</Typography>
                        }

                    </Box>
                    :
                    <Stack direction={'column'} spacing={printable ? 0 : 1} pb={3}>
                        {categories?.length > 0 && categories?.map(categorie => (
                            <Box key={categorie.key}>
                                <ComparaisonCard
                                    showExplenation={showExplenation}
                                    canChangeParam={canChangeParam}
                                    selectedExams={selectedExams}
                                    data={data}
                                    categorie={categorie}
                                    printable={printable}
                                />
                                {printable && <Divider sx={{ mt: 3 }} />}
                            </Box>
                        ))}
                    </Stack>
            }
        </>
    )
}

export default ComparaisonSection